import { urlForSpace } from "@src/utils/endpoints-urls";

export function urlForRideShare(spaceId: string): string {
  return `${urlForSpace(spaceId)}/ride-share`;
}

export function urlForRideShareSummary(spaceId: string): string {
  return `${urlForRideShare(spaceId)}/summary`;
}

export type RecentRidesParams = {
  limit?: number;
  /** Inclusive lower bound, YYYY-MM-DD. */
  startDate?: string;
  /** Inclusive upper bound, YYYY-MM-DD. */
  endDate?: string;
};

export function urlForRecentRides(
  spaceId: string,
  params: RecentRidesParams = {},
): string {
  const query = new URLSearchParams();
  if (params.limit !== undefined) query.set("limit", String(params.limit));
  if (params.startDate) query.set("startDate", params.startDate);
  if (params.endDate) query.set("endDate", params.endDate);

  const qs = query.toString();
  return `${urlForRideShare(spaceId)}/recent${qs ? `?${qs}` : ""}`;
}